export default __webpack_public_path__ + "static/media/bg_home.54e5e077.jpg";